<nav class="navbar navbar-expand-md navbar-dark fixed-top p-0">
    <a class="navbar-brand">
        <!-- <img src="./../../../assets/logo-banner.png" style="height: 60px;" class="tabView">
        <img src="./../../../assets/Digital_India_logo.png" style="height: 60px;" class="mobileView"> -->
        <img src="./../../../assets/Logo2.png" style="height: 60px;" class="tabView" alt="Dental Council of India"
            title="Dental Council of India">
        <!-- <a href="https://rashtragaan.in/">
            <img src="./../../../assets/Logo75.png" style="height: 60px;" class="tabView" alt="Dental Council of India"
                title="Dental Council of India">
        </a>
        <img src="./../../../assets/logoembdig.png" style="height: 60px;" class="tabView" alt="Dental Council of India"
            title="Dental Council of India"> -->
            <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 400px; height: 60px;">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse"
        aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="fas fa-bars" style="color: #fff;"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mr-auto">
            <!-- <li class="nav-item active">
                <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Link</a>
            </li>
            <li class="nav-item">
                <div class="nav-item dropdown" style="left: auto;">
                    <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">Messages</a>
                    <div class="dropdown-menu">
                        <a href="#" class="dropdown-item">Inbox</a>
                        <a href="#" class="dropdown-item">Sent</a>
                        <a href="#" class="dropdown-item">Drafts</a>
                    </div>
                </div>
            </li> -->
            <li class="nav-item" *ngIf="router.url.includes('/outbound') || router.url.includes('/inbound')">
                <div class="nav-item dropdown" style="left: 900%;display: none;" id="notIconDiv">
                    <button type="button" class="btn btn-secondary" data-toggle="dropdown">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-bell" viewBox="0 0 16 16">
                            <path
                                d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z">
                            </path>
                        </svg>
                        <span class="fa fa-comment"></span>
                        <span class="num" id="countText"></span>
                    </button>
                    <div class="dropdown-menu" [innerHTML]="noteCount" id="notificationCount"
                        style="left: auto;right: 20px !important;">

                    </div>

                </div>
            </li>
        </ul>
        <form class="form-inline mt-2 mt-md-0">
            <div class="nav-item dropdown">


                <img class="img-responsive img-rounded" src="./../../../assets/img_avatar.png" height="50" width="50"
                    alt="User picture">
                <a class="dropdown-toggle" data-toggle="dropdown"
                    style="padding: 0px 31px 0 10px;display: inline-block; color: #3170b7;font-weight: bold;cursor: pointer;text-align: right;">
                    <div class="details">
                        {{owner}}
                    </div>
                    <span hidden style="font-size: 12px;text-transform: capitalize">
                        {{roleName}}
                    </span>
                    <span *ngIf="roleName==='Advocate'" style="font-size: 12px;text-transform: capitalize">
                        {{roleName}}
                    </span>
                    <span style="font-size: 12px;text-transform: capitalize">
                        {{designation}}
                    </span>
                    <span *ngIf="roleName === 'College Principal' || roleName === 'College Representative'"
                        style="font-size: 12px;text-transform: capitalize">
                        {{collegeName}}
                    </span>
                    <span style="font-size: 12px;text-transform: capitalize"
                        *ngIf="roleName === 'College Dean'">
                        (ManavRachana Dental College)
                    </span>
                </a>
                <div class="dropdown-menu" style="left: auto;right: 20px !important;">
                    <ul class="p-0">
                        <li *ngIf="roleList.length > 1">
                            <a class="dropdown-item" data-toggle="modal" data-target="#roleModal">
                                <i class="fas fa-users-cog"></i> Change Role</a>
                        </li>
                        <li>
                            <!-- data-target="#passwordModal" -->
                            <!-- <a class="dropdown-item" data-toggle="modal" >
                                <i class="fa fa-key"></i> Change Password</a> -->
                            <a class="dropdown-item" #openModal data-target="#passwordModal" data-toggle="modal">
                                <i class="fa fa-key"></i> Change Password</a>
                        </li>
                        <li>
                            <a (click)="logoutAuditLog()" class="dropdown-item">
                                <i class="fas fa-sign-out-alt"></i> Logout
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </form>
    </div>
</nav>

<main role="main">
    <div class="page-wrapper chiller-theme">
        <a id="show-sidebar" class="btn btn-sm ">
            <i class="fas fa-chevron-circle-right" style="font-size: 20px;"></i> </a>
        <nav id="sidebar" class="sidebar-wrapper"
            [ngClass]="(!router.url.includes('/excu/ec/caseitem'))?'my-class1':'my-class2'">
            <div class="sidebar-content">
                <div class="sidebar-brand" style="color: #fff;font-weight: bold;">
                    Menu
                    <div id="close-sidebar" style="position: absolute;right: 10px;">
                        <i class="fas fa-chevron-circle-left" style="font-size: 20px;"></i>
                    </div>
                </div>
                <!-- sidebar-header  -->

                <!-- sidebar-search  -->
                <div class="sidebar-menu">
                    <ul>
                        <li class="nav-item"
                            *ngIf="(router.url.includes('main/internal/accfinace/'))  && (roleName==='Accounting_Finance_General')">
                            <a class="nav-link collapsed text-truncate" href="#submenu4" data-toggle="collapse"
                                data-target="#submenu4">
                                <img src="./../../../assets/My-Grievances-Status.png">
                                <span>Inspection</span></a>
                            <div class="collapse show" id="submenu4" aria-expanded="false">
                                <ul class="flex-column  nav">
                                    <li class="nav-item">
                                        <a class="nav-link p-8" routerLink="accfinace/dashboard"
                                            routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span>Approve Adjust TA Claim</span>
                                        </a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link p-8" routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span>Pay Claim</span>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </li>
                        <li class="nav-item"
                            *ngIf="(router.url.includes('main/internal/excu/ec'))  && (roleName==='Executive Committee')">
                            <a class="nav-link collapsed text-truncate" routerLinkActive="active" data-toggle="collapse"
                                data-target="#submenu5" routerLink="excu/ec/dashboard">
                                <img src="./../../../assets/My-Grievances-Status.png">
                                <span>Dashboard</span></a>
                            <div class="collapse show" id="submenu5" aria-expanded="false">
                                <ul class="flex-column  nav">

                                    <li *ngFor="let item of ecSidenav" class="nav-item" routerLink="{{item.router}}"
                                        routerLinkActive="active">
                                        <a class="nav-link p-8">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span>{{item.linkName}} </span>
                                        </a>
                                    </li>

                                    <li class="nav-item">
                                        <a class="nav-link p-8" href="#submenu6" routerLinkActive="active"
                                            data-toggle="collapse" data-target="#submenu6"
                                            routerLink="excu/ec/conductmeeting">
                                            <i class="fas fa-angle-right sidenavIcon"></i>

                                            <span>Conduct Meeting</span>
                                        </a>

                                        <div class="collapse" id="submenu6" aria-expanded="true">
                                            <ul class="flex-column  nav">
                                                <li class="nav-item" *ngFor="let sub of ecSubsidenav;let i=index">
                                                    <a class="nav-link p-8" routerLink="{{sub.router}}"
                                                        routerLinkActive="active">
                                                        <span class="sidenavIcon">{{i+1}}</span>
                                                        <span class="sub_Drop">{{sub.linkName}}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li class="nav-item"
                            *ngIf="(router.url.includes('main/internal/excu/CZsQVJe0x6'))  && (roleName==='Secretary' || roleName === 'Secretary Incharge'|| roleName === 'Joint Secretary')">
                            <a class="nav-link collapsed text-truncate" data-toggle="collapse" data-target="#submenu5">
                                <img src="./../../../assets/My-Grievances-Status.png">
                                <span>Meetings</span></a>

                            <div class="collapse show" id="submenu5" aria-expanded="false">
                        <li class="nav-item"
                            *ngIf="(roleName === 'Secretary' || roleName === 'Secretary Incharge'|| roleName === 'Joint Secretary')">
                            <a class="nav-link collapsed text-truncate"
                                routerLink="excu/CZsQVJe0x6/ReviewAgendaComponent" routerLinkActive="active">
                                <img src="./../../../assets/dashboard.png">
                                <span>Review Agenda Item</span></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link collapsed text-truncate"
                                routerLink="excu/CZsQVJe0x6/ReviewMinutesComponent" routerLinkActive="active">
                                <img src="./../../../assets/dashboard.png">
                                <span>Review Minutes</span></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link collapsed text-truncate"
                                routerLink="excu/CZsQVJe0x6/ReviewMeetingComponent" routerLinkActive="active">
                                <img src="./../../../assets/dashboard.png">
                                <span>Completed Meeting</span></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link collapsed text-truncate" routerLink="excu/CZsQVJe0x6/exportPdfAgendaList"
                                routerLinkActive="active">
                                <img src="./../../../assets/dashboard.png">
                                <span>PDF/Print Agenda</span></a>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link collapsed text-truncate" routerLink="excu/CZsQVJe0x6/trackAgendaList"
                                routerLinkActive="active">
                                <img src="./../../../assets/dashboard.png">
                                <span>Track Agenda</span></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link collapsed text-truncate" routerLink="excu/CZsQVJe0x6/trackMinutesList"
                                routerLinkActive="active">
                                <img src="./../../../assets/dashboard.png">
                                <span>Track Minutes</span></a>
                        </li>
                </div>
                </li>

                <li class="nav-item"
                    *ngIf="(router.url.includes('main/internal/excu/president'))  && (roleName==='President')">
                    <a class="nav-link collapsed text-truncate" data-toggle="collapse" data-target="#submenu5">
                        <img src="./../../../assets/My-Grievances-Status.png">
                        <span>Meetings</span></a>

                    <div class="collapse show" id="submenu5" aria-expanded="false">
                <li class="nav-item">
                    <a class="nav-link collapsed text-truncate"
                        routerLink="excu/president/presidentReviewAgendaComponent" routerLinkActive="active">
                        <img src="./../../../assets/dashboard.png">
                        <span>Review Agenda Item</span></a>
                </li>

                <li class="nav-item">
                    <a class="nav-link collapsed text-truncate"
                        routerLink="excu/president/presidentReviewMinutesComponent" routerLinkActive="active">
                        <img src="./../../../assets/dashboard.png">
                        <span>Review Minutes</span></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link collapsed text-truncate"
                        routerLink="excu/president/presidentReviewMeetingComponent" routerLinkActive="active">
                        <img src="./../../../assets/dashboard.png">
                        <span>Completed Meeting</span></a>
                </li>
                <!-- <li class="nav-item">
                            <a class="nav-link collapsed text-truncate"
                                routerLink="excu/president/exportPdfAgendaList" routerLinkActive="active">
                                <img src="./../../../assets/dashboard.png">
                                <span>PDF/Print Agenda</span></a>
                        </li>               -->
                <li class="nav-item">
                    <a class="nav-link collapsed text-truncate" routerLink="excu/president/trackAgendaList"
                        routerLinkActive="active">
                        <img src="./../../../assets/dashboard.png">
                        <span>Track Agenda</span></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link collapsed text-truncate" routerLink="excu/president/trackMinutesList"
                        routerLinkActive="active">
                        <img src="./../../../assets/dashboard.png">
                        <span>Track Minutes</span></a>
                </li>
            </div>
            </li>

            <li *ngIf="router.url.includes('main/internal/dashboard')">
                <a routerLink="dashboard" routerLinkActive="active">
                    <img src="./../../../assets/dashboard.png">
                    <span>Home </span>
                </a>
            </li>
            <li
                *ngIf="(router.url.includes('usrmgt')) && (roleName === 'System Admin' || roleName === 'ServerSecExecutive')">
                <a routerLink="usrmgt/internalApp" routerLinkActive="active">
                    <img src="./../../../assets/My-Grievances-Status.png">
                    <span>User Management</span>
                </a>
            </li>
            <!--New College-->
            <li class="nav-item" *ngIf="(router.url.includes('main/internal/ug')) && roleName==='NewCollege'">
                <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse"
                    data-target="#submenu1">
                    <img src="./../../../assets/My-Grievances-Status.png">
                    <span>New College</span></a>
                <div class="collapse show" id="submenu1" aria-expanded="false">
                    <ul class="flex-column  nav">
                        <li class="nav-item">
                            <a class="nav-link p-8" routerLink="/main/internal/ug/NewCollege" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Apply for a New College</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link p-8" routerLink="/main/internal/ug/dashboard" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>New College Dashboard</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link p-8" routerLink="/main/internal/ug/collegeView" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>College Registered List View
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>


            <!--SDC-->
            <li class="nav-item"
                *ngIf="(router.url.includes('main/internal/uidr')) && (roleName==='ARPMSecInCharge' ||  roleName === 'ARPMAsstSecty' ||  roleName === 'ARPMAssistantSectionOfficer' ||  roleName === 'ARPMSecExecutive' ||  roleName === 'UIDR')">
                <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse"
                    data-target="#submenu1">
                    <img src="./../../../assets/My-Grievances-Status.png">
                    <span>UIDR</span></a>
                <div class="collapse show" id="submenu1" aria-expanded="false">
                    <ul class="flex-column  nav">
                        <li class="nav-item">
                            <a class="nav-link p-8" routerLink="/main/internal/uidr/sectionDashboard" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Indian Dentists Register</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <!-- <li class="nav-item" *ngIf="(router.url.includes('/uidr')) && roleName==='Dentist'">
                        <div class="collapse show" id="submenu1" aria-expanded="false">
                             <ul class="flex-column  nav">
                                <li class="nav-item">
                                    <a class="nav-link p-8" routerLink="/main/internal/uidr/candidate/uidrList" routerLinkActive="active">
                                        <i class="fas fa-angle-right sidenavIcon"></i>
                                        <span>Existing Registration</span>
                                    </a>
                                </li>
                            </ul>
                          <ul class="flex-column  nav" *ngIf="!editpermission">
                                <li class="nav-item">
                                    <a class="nav-link p-8" routerLink="/main/internal/uidr/uidrRegistration" routerLinkActive="active">
                                        <i class="fas fa-angle-right sidenavIcon"></i>
                                        <span>UIDR Registration</span>
                                    </a>
                                </li>
                            </ul> -->
            <!--   <ul class="flex-column  nav">
                                <li class="nav-item">
                                    <a class="nav-link p-8" routerLink="/main/internal/uidr/uidrTransferList" routerLinkActive="active">
                                        <i class="fas fa-angle-right sidenavIcon"></i>
                                        <span>Update Transfer of Registration</span>
                                    </a>
                                </li>
                            </ul> -->
            <!-- </div>
                    </li> -->
            <!-- <li class="nav-item" *ngIf="(router.url.includes('/uidr')) && roleName==='SDC'"> -->
            <!-- <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse"
                        data-target="#submenu1"  routerLink="/main/internal/uidr/uidrList" routerLinkActive="active">
                        <img src="./../../../assets/My-Grievances-Status.png">
                        <span>UIDR</span></a> -->
            <!-- <div class="collapse show" id="submenu1" aria-expanded="false">
                         <ul class="flex-column  nav">
                            <li class="nav-item">
                                <a class="nav-link p-8" routerLink="/main/internal/uidr/uidrList" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Indian Dentists Register</span>
                                </a>
                            </li>
                        </ul> -->
            <!--<ul class="flex-column  nav">
                            <li class="nav-item">
                                <a class="nav-link p-8" routerLink="/main/internal/uidr/uidrRegistration" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>UIDR Registration</span>
                                </a>
                            </li>
                        </ul> -->
            <!-- <ul class="flex-column  nav">
                            <li class="nav-item">
                                <a class="nav-link p-8" routerLink="/main/internal/uidr/uidrRenewList" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Renew / Update Registration</span>
                                </a>
                            </li>
                        </ul>
                        <ul class="flex-column  nav">
                            <li class="nav-item">
                                <a class="nav-link p-8" routerLink="/main/internal/uidr/uidrTransferList" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Update Transfer of Registration</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li> -->
            <!-- Added by gokul for grievance college Complaint -->
            <li class="nav-item"
                *ngIf="(router.url.includes('grievance/complaint')) && (roleName === 'College Principal' || roleName==='General Public' || roleName === 'Student')">
                <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse"
                    data-target="#submenu1">
                    <img src="./../../../assets/My-Grievances-Status.png">
                    <span>Grievance</span></a>
                <div class="collapse show" id="submenu1" aria-expanded="false">
                    <ul class="flex-column  nav">
                        <li class="nav-item">
                            <a class="nav-link p-8" routerLink="grievance/complaint/new" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Raise Complaint</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link p-8" routerLink="grievance/complaint/dashboard"
                                routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Complaint Dashboard</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>

            <!-- Added by gokul for grievance Section Head -->
            <li class="nav-item"
                *ngIf="(router.url.includes('grievance/section')) && (roleName==='PDMSSecInCharge' || 
                roleName==='PDMSAsstSecty' || roleName==='PDMSSectionOfficer' || roleName==='PDMSAssistantSectionOfficer' || roleName==='PDMSExecutive') && (previlizesList.includes('GRIEVANCEDASHBOARD'))">
                <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse"
                    data-target="#submenu1">
                    <img src="./../../../assets/My-Grievances-Status.png">
                    <span>Grievance</span></a>
                <div class="collapse show" id="submenu1" aria-expanded="false">
                    <ul class="flex-column  nav">
                        <li class="nav-item">
                            <a class="nav-link p-8" routerLink="grievance/section/dashboard" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Complaint Dashboard</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link p-8" routerLink="grievance/section/trackDashboard" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Track Complaint Dashboard</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <!-- <li class="nav-item" *ngIf="(router.url.includes('excu/sectionHead')) && (roleName==='PDMSSecInCharge')">
                            <a class="nav-link collapsed text-truncate" routerLink="excu/sectionHead/sectionDashboard" routerLinkActive="active">
                                <img src="./../../../assets/dashboard.png">
                                <span>Refine Meeting Minutes</span></a>
                        </li>-->
            <li class="nav-item"
                *ngIf="(router.url.includes('excu/sectionHead')) && (roleName==='PDMSSecInCharge' || roleName==='ARPMSecInCharge' || roleName==='AcademicIncharge' || roleName==='AEIncharge' || roleName==='AFSecInCharge' || roleName==='LegalSecInCharge' || roleName==='AdmsnIncharge' || roleName==='ISecInCharge' || roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' || roleName==='InspAsstSecty' || roleName==='MSAsstSecty')">
                <a class="nav-link collapsed text-truncate" data-toggle="collapse" data-target="#submenu5">
                    <img src="./../../../assets/My-Grievances-Status.png">
                    <span>Meetings</span></a>
                <div class="collapse show" id="submenu5" aria-expanded="false">
            <li class="nav-item"
                *ngIf="(router.url.includes('excu/sectionHead')) && (roleName==='PDMSSecInCharge' || roleName==='ARPMSecInCharge' || roleName==='AcademicIncharge' || roleName==='AEIncharge' || roleName==='AFSecInCharge' || roleName==='LegalSecInCharge' || roleName==='AdmsnIncharge' || roleName==='ISecInCharge' || roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' || roleName==='InspAsstSecty' || roleName==='MSAsstSecty')">
                <a class="nav-link collapsed text-truncate" routerLink="excu/sectionHead/agendaDashBoard"
                    routerLinkActive="active">
                    <img src="./../../../assets/dashboard.png">
                    <span>Agenda DashBoard</span></a>
            </li>
    </div>
    <div class="collapse show" id="submenu5" aria-expanded="false">
        <li class="nav-item"
            *ngIf="(router.url.includes('excu/sectionHead')) && (roleName==='PDMSSecInCharge' || roleName==='ARPMSecInCharge' || roleName==='AcademicIncharge' || roleName==='AEIncharge' || roleName==='AFSecInCharge' || roleName==='LegalSecInCharge' || roleName==='AdmsnIncharge' || roleName==='ISecInCharge' || roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' || roleName==='InspAsstSecty' || roleName==='MSAsstSecty')">
            <a class="nav-link collapsed text-truncate"
                routerLink="excu/sectionHead/completedMeetingSectionheadDashboard" routerLinkActive="active">
                <img src="./../../../assets/dashboard.png">
                <span>Completed Meeting</span></a>
        </li>
        <li class="nav-item"
            *ngIf="(router.url.includes('excu/sectionHead')) && (roleName==='PDMSSecInCharge' || roleName==='ARPMSecInCharge' || roleName==='AcademicIncharge' || roleName==='AEIncharge' || roleName==='AFSecInCharge' || roleName==='LegalSecInCharge' || roleName==='AdmsnIncharge' || roleName==='ISecInCharge' || roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' || roleName==='InspAsstSecty' || roleName==='MSAsstSecty')">
            <a class="nav-link collapsed text-truncate" routerLink="excu/sectionHead/exportPdfAgendaList"
                routerLinkActive="active">
                <img src="./../../../assets/dashboard.png">
                <span>PDF/Print Agenda</span></a>
        </li>
        <li class="nav-item"
            *ngIf="(router.url.includes('excu/sectionHead')) && (roleName==='PDMSSecInCharge' || roleName==='ARPMSecInCharge' || roleName==='AcademicIncharge' || roleName==='AEIncharge' || roleName==='AFSecInCharge' || roleName==='LegalSecInCharge' || roleName==='AdmsnIncharge' || roleName==='ISecInCharge' || roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' || roleName==='InspAsstSecty' || roleName==='MSAsstSecty')">
            <a class="nav-link collapsed text-truncate" routerLink="excu/sectionHead/trackAgendaList"
                routerLinkActive="active">
                <img src="./../../../assets/dashboard.png">
                <span>Track Agenda</span></a>
        </li>
    </div>
    <!-- <div class="collapse show" id="submenu5" aria-expanded="false">
                <li class="nav-item"
                    *ngIf="(router.url.includes('excu/sectionHead')) && (roleName==='PDMSSecInCharge' || roleName==='ARPMSecInCharge' || roleName==='AcademicIncharge' || roleName==='AEIncharge' || roleName==='AFSecInCharge' || roleName==='LegalSecInCharge' || roleName==='AdmsnIncharge' || roleName==='ISecInCharge' || roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' || roleName==='InspAsstSecty' || roleName==='MSAsstSecty')">
                    <a class="nav-link collapsed text-truncate" routerLink="excu/sectionHead/refinementDashBoard"
                        routerLinkActive="active">
                        <img src="./../../../assets/dashboard.png">
                        <span>Refinement Dashboard</span></a>
                </li>
            </div> -->
    </li>
    <li class="nav-item"
        *ngIf="(router.url.includes('excu/viewAgenda')) && ((roleName==='AFExecutive' || roleName==='RTIExecutive'|| roleName==='AcademicExecutive'|| roleName==='ServerSecExecutive' || roleName==='PDMSExecutive'  
            || roleName==='AcademicSectionOfficer' || roleName === 'RTISectionOfficer' || roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnSecExecutive'  || roleName === 'AdmsnAssistantSectionOfficer' || roleName==='PDMSSectionOfficer' || roleName==='AFSectionOfficer' || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSectionOfficer'
            ||roleName==='Accountant'||roleName==='AcademicAssistantSectionOfficer' ||roleName==='PDMSAssistantSectionOfficer' || roleName === 'ARPMAssistantSectionOfficer' || roleName==='ARPMSecExecutive' || roleName === 'RTIAssistantSectionOfficer' || roleName === 'AEAssistantSectionOfficer' ||roleName==='LegalExecutive'
            ||roleName==='LegalAssistantSectionOfficer'||roleName==='AESectionofficer'|| roleName==='AEExecutive'||roleName==='AESectionofficer' ||roleName==='AFAssistantSectionOfficer' || roleName ==='AcademicAsstSecty'|| roleName ==='AEAssistantSecretary'||roleName==='ARPMAsstSecty'||roleName==='PDMSAsstSecty'||roleName ==='AdmsnAsstSecty'))">
        <a class="nav-link collapsed text-truncate" data-toggle="collapse" data-target="#submenu5">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Meetings</span></a>
    </li>
    <li class="nav-item"
        *ngIf="(router.url.includes('excu/sectionExcutive')) && ((roleName==='AFExecutive' || roleName==='RTIExecutive'|| roleName==='AcademicExecutive'|| roleName==='ServerSecExecutive' || roleName==='PDMSExecutive' 
            || roleName==='AcademicSectionOfficer' || roleName === 'RTISectionOfficer' || roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnSecExecutive'  || roleName === 'AdmsnAssistantSectionOfficer' || roleName==='PDMSSectionOfficer' || roleName==='AFSectionOfficer' || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSectionOfficer'
            ||roleName==='Accountant'||roleName==='AcademicAssistantSectionOfficer' ||roleName==='PDMSAssistantSectionOfficer' || roleName === 'ARPMAssistantSectionOfficer' || roleName==='ARPMSecExecutive' || roleName === 'RTIAssistantSectionOfficer' || roleName === 'AEAssistantSectionOfficer' ||roleName==='LegalExecutive'
            ||roleName==='LegalAssistantSectionOfficer'||roleName==='AESectionofficer'|| roleName==='AEExecutive'||roleName==='AESectionofficer' ||roleName==='AFAssistantSectionOfficer' || roleName ==='AcademicAsstSecty'|| roleName ==='AEAssistantSecretary'||roleName==='ARPMAsstSecty'||roleName==='PDMSAsstSecty'||roleName ==='AdmsnAsstSecty'))">
        <a class="nav-link collapsed text-truncate" data-toggle="collapse" data-target="#submenu5">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Meetings</span></a>
        <div class="collapse show" id="submenu5" aria-expanded="false">
    <li class="nav-item">
        <a class="nav-link collapsed text-truncate" routerLink="excu/sectionExcutive/secExeAgendaDashBoard"
            routerLinkActive="active">
            <img src="./../../../assets/dashboard.png">
            <span>Agenda DashBoard</span></a>
    </li>
    <li class="nav-item">
        <a class="nav-link collapsed text-truncate" routerLink="excu/sectionExcutive/exportPdfAgendaList"
            routerLinkActive="active">
            <img src="./../../../assets/dashboard.png">
            <span>PDF/Print Agenda</span></a>
    </li>
    <li class="nav-item">
        <a class="nav-link collapsed text-truncate" routerLink="excu/sectionExcutive/trackAgendaList"
            routerLinkActive="active">
            <img src="./../../../assets/dashboard.png">
            <span>Track Agenda</span></a>
    </li>
    </div>
    </li>
    <!-- inspection  -->
    <li class="nav-item"
        *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/'))) && 
        (roleName==='InspectionCell'|| roleName==='President'  || roleName==='System Admin')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let insCell of InspCellForChairperson">
                    <a class="nav-link p-8" routerLink="{{insCell.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{insCell.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
        <a class="nav-link collapsed text-truncate" href="#submenu3" data-toggle="collapse" data-target="#submenu3">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection Master Details</span></a>
            <div class="collapse hide" id="submenu3" aria-expanded="false">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="inspection/inspMaster/holiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/collegeholiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>College Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspSubType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Sub Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspPurpose" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Purpose </span>
                        </a>
                    </li>
                </ul>
            </div>
    </li>

    <!-- inspection  -->
    <li class="nav-item"
        *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/'))) && 
        (roleName==='Inspection Executive')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let insCell of InspCellForInspectionExecutive">
                    <a class="nav-link p-8" routerLink="{{insCell.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{insCell.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
        <a class="nav-link collapsed text-truncate" href="#submenu3" data-toggle="collapse" data-target="#submenu3">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection Master Details</span></a>
            <div class="collapse hide" id="submenu3" aria-expanded="false">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="inspection/inspMaster/holiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/collegeholiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>College Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspSubType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Sub Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspPurpose" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Purpose </span>
                        </a>
                    </li>
                </ul>
            </div>
    </li>
    <!-- inspection  -->
    <li class="nav-item"
        *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/'))) && 
        (roleName==='InspectionCell'|| roleName==='Chairperson')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let insCell of InspCellForChairperson">
                    <a class="nav-link p-8" routerLink="{{insCell.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{insCell.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
        <a class="nav-link collapsed text-truncate" href="#submenu3" data-toggle="collapse" data-target="#submenu3">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection Master Details</span></a>
            <div class="collapse hide" id="submenu3" aria-expanded="false">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="inspection/inspMaster/holiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/collegeholiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>College Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspSubType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Sub Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspPurpose" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Purpose </span>
                        </a>
                    </li>
                </ul>
            </div>
    </li>

    <li class="nav-item"
        *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/'))) && 
        (roleName==='AcademicIncharge' || roleName==='AcademicAsstSecty' || roleName==='AcademicSectionOfficer' || roleName==='AcademicAssistantSectionOfficer' 
        || roleName==='AcademicExecutive')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let insCell of InsCellForAcademic">
                    <a class="nav-link p-8" routerLink="{{insCell.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{insCell.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
        <a class="nav-link collapsed text-truncate" href="#submenu3" data-toggle="collapse" data-target="#submenu3">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection Master Details</span></a>
            <div class="collapse hide" id="submenu3" aria-expanded="false">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="inspection/inspMaster/inspType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspSubType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Sub Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspPurpose" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Purpose </span>
                        </a>
                    </li>
                </ul>
            </div>
    </li>

    <li class="nav-item"
        *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/'))) && 
        (roleName==='PDMSSectionOfficer' || roleName==='PDMSAssistantSectionOfficer' || roleName==='PDMSExecutive' || roleName==='PDMSSecInCharge' 
        || roleName==='PDMSAsstSecty'|| roleName==='PDMSExecutive(MTS)')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let insCell of InsCellForPDMS">
                    <a class="nav-link p-8" routerLink="{{insCell.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{insCell.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
        <a class="nav-link collapsed text-truncate" href="#submenu3" data-toggle="collapse" data-target="#submenu3">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection Master Details</span></a>
            <div class="collapse hide" id="submenu3" aria-expanded="false">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="inspection/inspMaster/inspType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspSubType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Sub Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspPurpose" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Purpose </span>
                        </a>
                    </li>
                </ul>
            </div>
    </li>
    <li class="nav-item"
        *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/'))) && 
        ( roleName==='Joint Secretary')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let insCell of InsCellForSecretaryIncharge">
                    <a class="nav-link p-8" routerLink="{{insCell.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{insCell.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>
  <!-- Server Section Executive -->
  <li class="nav-item" *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/')) )  && roleName==='ServerSecExecutive'">
    <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
        <img src="./../../../assets/My-Grievances-Status.png">
        <span>Inspection</span></a>
    <div class="collapse show" id="submenu2" aria-expanded="false">
        <ul class="flex-column  nav">
            <li class="nav-item" *ngFor="let link of InsCellForSeverExecutive">
                <a class="nav-link p-8" routerLink="{{link.router}}" routerLinkActive="active">
                    <i class="fas fa-angle-right sidenavIcon"></i>
                    <span>{{link.linkName}}</span>
                </a>
            </li>
        </ul>
    </div>
 
        <a class="nav-link collapsed text-truncate" href="#submenu3" data-toggle="collapse" data-target="#submenu3">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection Master Details</span></a>
            <div class="collapse hide" id="submenu3" aria-expanded="false">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="inspection/inspMaster/holiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspSubType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Sub Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspPurpose" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Purpose </span>
                        </a>
                    </li>
                </ul>
            </div>
    </li>
    <!-- InspAsstSecty -->
    <li class="nav-item" *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/')) )  && (roleName==='InspAsstSecty')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let link of InspSec">
                    <a class="nav-link p-8" routerLink="{{link.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{link.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
        <a class="nav-link collapsed text-truncate" href="#submenu3" data-toggle="collapse" data-target="#submenu3">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection Master Details</span></a>
            <div class="collapse hide" id="submenu3" aria-expanded="false">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="inspection/inspMaster/holiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/collegeholiday" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>College Holiday Master </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspSubType" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Sub Type </span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="inspection/inspMaster/inspPurpose" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span> Inspection Purpose </span>
                        </a>
                    </li>
                </ul>
            </div>
    
    </li>
      <!-- Secretary Incharge -->
    <li class="nav-item" *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/')) )  && (roleName==='Secretary Incharge' )">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let link of InsCellForSecretaryIncharge">
                    <a class="nav-link p-8" routerLink="{{link.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{link.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
       
    </li>

    <li class="nav-item" *ngIf="(router.url.includes('inspection/insCell/') || (router.url.includes('inspection/inspMaster/')) )  && (roleName==='Secretary' )">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let link of InsCellForSecretaryIncharge">
                    <a class="nav-link p-8" routerLink="{{link.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{link.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
       
    </li>

    <!-- inspection  for account by gokul-->
    <li class="nav-item" *ngIf="(router.url.includes('inspection/insCell/'))  && (roleName==='AFSectionOfficer')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Inspection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li class="nav-item" *ngFor="let InsCellForAcccount of InsCellForAcccount">
                    <a class="nav-link p-8" routerLink="{{InsCellForAcccount.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{InsCellForAcccount.linkName}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>


    <!-- Travel Agent tavelagent -->
    <li class="nav-item" *ngIf="(router.url.includes('inspection/tavelagent/')) && (roleName==='TravelAgent')">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Travel Agent</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column nav">
                <li class="nav-item" *ngFor="let travel of travelAgent">
                    <a class="nav-link p-8" routerLink="{{travel.router}}" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>{{travel.linkName}}</span>
                    </a>
                </li>


            </ul>
        </div>
    </li>
    <!--  inspectionproforma added by gokul -->

    <!-- <li class="nav-item" *ngIf="router.url.includes('main/internal/inspection/inspectionproforma')  && roleName==='Inspector'">
                                        <a class="nav-link p-8" href="#submenuForperfoma" routerLinkActive="active"
                                            data-toggle="collapse" data-target="#submenuForperfoma"
                                            routerLink="inspection/inspectionproforma/contactInspectionDasboard">
                                            <img src="./../../../assets/My-Grievances-Status.png">
                                            <span>Conduct Inspection</span>
                                        </a>

                                        <div class="collapse" id="submenuForperfoma" aria-expanded="true">
                                            <ul class="flex-column  nav">
                                                <li class="nav-item" *ngFor="let sub of Insproforma;let i=index">
                                                    <a class="nav-link p-8" routerLink="{{sub.router}}"
                                                        routerLinkActive="active">
                                                        <i class="fas fa-angle-right sidenavIcon"></i>
                                                        <span class="sub_Drop">{{sub.linkName}}</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li> -->
    <!--Added for Self Assessment Report-->
    <li class="nav-item"
        *ngIf="router.url.includes('main/internal/inspection/inspectionproforma')  && roleName==='Inspector'">
        <a class="nav-link collapsed text-truncate" href="#submenuForperfoma" data-toggle="collapse"
            data-target="#submenuForperfoma">
            <img src="./../../../assets/dashboard.png">
            <span (click)="conductInspection()" routerLink="inspection/inspectionproforma/contactInspectionDasboard"
                routerLinkActive="active">Conduct Inspection</span></a>
        <div *ngIf="conductInspCourse === '1'" class="collapse show" id="submenuForperfoma" aria-expanded="true">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="inspection/inspectionproforma/collegeInformation" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> College Information </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/generalInformation" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> General Information </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/clinicalWorkLoad" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Attached Hospital + Clinical <span style="padding-left: 10%;">Workload</span> </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/infrastructure" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Infrastructure </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/equipments" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Equipments </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/teachingStaff" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Teaching Staff </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/nonTeachingStaffList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Non-Teaching Staff </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/libraryDetails" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Library Details </span>
                    </a>
                </li>     
                <li>
                    <a routerLink="inspection/inspectionproforma/submitInspection" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Submit Inspection </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/inspectionReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Inspection Report</span>
                    </a>
                </li>           
                <li>
                    <a routerLink="inspection/inspectionproforma/deficiencyReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Deficiency Report</span>
                    </a>
                </li>
            </ul>
        </div>
        <div *ngIf="conductInspCourse === '2'" class="collapse show" id="submenuForperfoma" aria-expanded="true">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="inspection/inspectionproforma/collegeInformation" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>College Information</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/generalInformation" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>General Information</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/clinicalWorkLoad" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Clinical Work Load</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/hostelFacility" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Hostel Facility for PG</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/infrastructure" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Speciality Department <span style="padding-left:10%;">Infrastructure Details</span></span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/equipments" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Equipments</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/teachingStaff" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Teaching Staff</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/staffAssessmentPublications" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Staff Assessment for <span style="padding-left:10%;">Publications</span></span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/libraryDetails" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Library Details</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/lastAnnualAdmissionSpecialty"
                        routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Last Annual Admission details for <span style="padding-left:10%;">Speciality
                            </span></span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/studentAcademicDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Academic Presentation</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/teachingLearningActivitiesDashboard"
                        routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Teaching/Learning Activities</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/submitInspection" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Submit Inspection </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/inspectionReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Inspection Report</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inspection/inspectionproforma/deficiencyReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Deficiency Report</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>
    <!--darkDairy-->
    <li class="nav-item" *ngIf="(router.url.includes('inbound/')) && (roleName==='RDSecInCharge')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">

                <li>
                    <a routerLink="inbound/diarydakincharge/receiptDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Receipt Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/trackReceiptDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Receipt</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/createReceipt" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Create Receipt</span>
                    </a>
                </li>
                <!-- <li>
                    <a routerLink="inbound/sectionincharge/acknDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Acknowledgement Dashboard</span>

                    </a>
                </li> -->
                <!-- <li>
                            <a routerLink="inbound/diarydakincharge/dispatchdashboard" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span> Dispatch Dashboard</span>
                            </a>
                        </li> -->


                <!-- <li>
                                        <a routerLink="inbound/diarydakincharge/anothersection"
                                            routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span> Other Section Dispatches </span>
                                        </a>
                                    </li> -->

            </ul>
        </div>
    </li>
    <!--darkDairy-->

    <!-- AFSECTIONINCHARGE -->
    <li class="nav-item" *ngIf="(router.url.includes('inbound/')) && (roleName==='R&DSecExecutive')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">

                <!-- <li>
                            <a routerLink="inbound/diarydakincharge/receiptDashboard" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Receipt Dashboard</span>
                            </a>
                        </li>
                        <li>
                            <a routerLink="inbound/diarydakincharge/createReceipt" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span> Create Receipt</span>
                            </a>
                        </li> -->
                <li>
                    <a routerLink="inbound/diarydakincharge/dispatchdashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Dispatch Dashboard</span>
                    </a>
                </li>
            
                <li>
                    <a routerLink="inbound/diarydakincharge/acknowledgementdashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Acknowledgement Dashboard</span>
                    </a>
                </li> 


                <!-- <li>
                                        <a routerLink="inbound/diarydakincharge/anothersection"
                                            routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span> Other Section Dispatches </span>
                                        </a>
                                    </li> -->

            </ul>
        </div>
    </li>
    <!--darkDairy-->
    <li class="nav-item"
        *ngIf="((router.url.includes('outbound/'))||(router.url.includes('inbound/secretary'))||(router.url.includes('inbound/diarydakincharge'))||(router.url.includes('outbound/CZsQVJe0x6/')) ) && (roleName === 'Joint Secretary' || roleName === 'Secretary' || roleName === 'Secretary Incharge')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">

                <!-- <li>
                                        <a routerLink="inbound/secretary" routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span>Receipt Dashboard</span>
                                        </a>
                                    </li> -->


                <li *ngIf="previlizesList.includes('Non Dak Section Head Dispatch Dashboard')">
                    <a routerLink="outbound/CZsQVJe0x6/dashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Note Sheet Dashboard</span>
                    </a>
                </li>

                <!-- <li>
                    <a routerLink="outbound/secretary/acknDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Acknowledgement Dashboard</span>
                    </a>
                </li>  -->

                <li>
                    <a routerLink="outbound/se/trackNotesheetSecExec" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Note Sheet</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Create Dispatch Note Sheet')">
                    <a routerLink="outbound/se/createNoteSheet/0" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Put Up Note Sheet</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Non Dak Section Head Dispatch Dashboard')">
                    <a routerLink="outbound/CZsQVJe0x6/dispatchDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Dispatch Dashboard</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Quaterly Report')">
                    <a routerLink="outbound/quaterlyReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Quaterly Report</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/diarydakreport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>File Directory</span>

                    </a>
                </li>
                <!-- <li>
                                        <a routerLink="outbound/secretary/otherSecDispatches" routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span> Other Section Dispatches </span>
                                        </a>
                                    </li> -->

                <!-- <li *ngIf="previlizesList.includes('View Despatch')">
                                        <a routerLink="outbound/secretary/view" routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span>View Note Sheet/Letter</span>
                                        </a>
                                    </li> -->



            </ul>
        </div>
    </li>

    <!--darkDairy-->
    <li class="nav-item"
        *ngIf="((router.url.includes('outbound/'))||(router.url.includes('inbound/president'))||(router.url.includes('inbound/diarydakincharge'))||(router.url.includes('outbound/president/')) ) && (roleName==='President')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li *ngIf="previlizesList.includes('Non Dak Section Head Dispatch Dashboard')">
                    <a routerLink="outbound/president/dashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Note Sheet Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/trackNotesheetSecExec" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Note Sheet</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Non Dak Section Head Dispatch Dashboard')">
                    <a routerLink="outbound/president/dispatchDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Dispatch Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/diarydakreport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>File Directory</span>

                    </a>
                </li>
            </ul>
        </div>
    </li>
  <!--darkDairy-->
    <li class="nav-item"
        *ngIf="((router.url.includes('outbound/'))||(router.url.includes('inbound/president'))||(router.url.includes('inbound/diarydakincharge'))||(router.url.includes('outbound/president/')) ) && (roleName==='Chairperson')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li *ngIf="previlizesList.includes('Non Dak Section Head Dispatch Dashboard')">
                    <a routerLink="outbound/president/dashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Note Sheet Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/trackNotesheetSecExec" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Note Sheet</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Non Dak Section Head Dispatch Dashboard')">
                    <a routerLink="outbound/president/dispatchDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Dispatch Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/diarydakreport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>File Directory</span>

                    </a>
                </li>
            </ul>
        </div>
    </li>
    <!-- AFSECTION INCHARGE -->
    <li class="nav-item"
        *ngIf="((router.url.includes('outbound/se/'))||(router.url.includes('outbound/secInch/'))||(router.url.includes('inbound/'))||(router.url.includes('outbound/')))&& ((roleName==='AFSecInCharge' ||
                        roleName==='AdmsnIncharge' || roleName==='AcademicIncharge' ||roleName==='LegalSecInCharge'||
                        roleName==='AEIncharge' ||roleName==='ISecInCharge' ||roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' ||roleName ==='ARPMSecInCharge'||roleName ==='PDMSSecInCharge'))">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="inbound/sectionincharge/receiptDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Receipt Dashboard</span>

                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionincharge/trackReceiptDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Receipt </span>

                    </a>
                </li>
            
                <li *ngIf="previlizesList.includes('Create Dispatch Note Sheet')">
                    <a routerLink="outbound/se/createNoteSheet/0" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Put Up Note Sheet</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/secInch/IncDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Note Sheet Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/secInch/trackNotesheet" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Note Sheet</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/secInch/correctionList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Correct Note Sheet</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/secInch/secInchDispatchDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Dispatch Dashboard</span>

                    </a>
                </li>
                <li
                    *ngIf="roleName ==='PDMSSecInCharge'||roleName ==='ARPMSecInCharge'||roleName==='AEIncharge'||roleName==='AcademicIncharge'||roleName==='AdmsnIncharge'||roleName==='AFSecInCharge'||roleName==='LegalSecInCharge'||roleName==='ISecInCharge'||roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' ">
                    <a routerLink="inbound/sectionincharge/OtherSecDispatch" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Other Section Dispatches </span>
                    </a>
                </li>
                <li
                    *ngIf="roleName ==='PDMSSecInCharge'||roleName ==='ARPMSecInCharge'||roleName==='AEIncharge'||roleName==='AcademicIncharge'||roleName==='AdmsnIncharge'||roleName==='AFSecInCharge'||roleName==='LegalSecInCharge'||roleName==='ISecInCharge'||roleName==='RTISecInCharge' || roleName==='ServerSecInCharge'">
                    <a routerLink="outbound/secInch/sectionClarification" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Received from Other Section(s) </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionincharge/acknDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Acknowledgement Dashboard</span>

                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/diarydakreport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>File Directory</span>

                    </a>
                </li>
                <!-- <li *ngIf="roleName ==='ARPMSecInCharge'">
                                        <a routerLink="outbound/secInch/historyNotesheet" routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span>Notesheet History</span>

                                        </a>
                                    </li>-->
                <!-- view ,return,approve -->
            </ul>
        </div>
    </li>
    <!-- AFSECTIONINCHARGE -->
    <!--  SSA -->
    <li class="nav-item"
        *ngIf="((router.url.includes('outbound/')) ||(router.url.includes('outbound/se/'))||(router.url.includes('inbound/sectionexecutive'))||(router.url.includes('inbound/diarydakincharge')))&& (roleName==='Student Admission Executive' || roleName==='DAK_Section_Executive')">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="inbound/sectionexecutive/dashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Receipt Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionexecutive/trackDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Receipt </span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Create Dispatch Note Sheet')">
                    <a routerLink="outbound/se/createNoteSheet/0" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Put Up Note Sheet</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Section Exec Dispatch Dashboard')">
                    <a routerLink="outbound/se/dashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Note Sheet Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/trackNotesheetSecExec" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Note Sheet</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/correctionList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Correct Note Sheet</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Section Exec Dispatch Dashboard')">
                    <a routerLink="outbound/se/dispatchDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Dispatch Dashboard</span>
                    </a>
                </li>
                <li *ngIf="roleName==='DAK_Section_Executive'">
                    <a routerLink="inbound/diarydakincharge/dispatchdashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Dispatch Dashboard</span>
                    </a>
                </li>
               

                
                <li>
                    <a routerLink="inbound/sectionexecutive/otherSecDispatches" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Other Section Dispatches </span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/secExeClarificationList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Received from Other Section(s) </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionexecutive/acknowledgementDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Acknowledgement Dashboard </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/diarydakreport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>File Directory</span>

                    </a>
                </li>
                <!-- seekapproval  major correction view check privileges -->
            </ul>
        </div>
    </li>
    <!-- SSA -->
    <!--  SSA -->
    <li class="nav-item"
        *ngIf="((router.url.includes('outbound/')) ||(router.url.includes('inbound/sectionexecutive'))||(router.url.includes('inbound/diarydakincharge'))||
                        (router.url.includes('outbound/se/')))&&((roleName==='AFExecutive' || roleName==='RTIExecutive'|| roleName==='AcademicExecutive' || roleName==='ServerSecExecutive' || roleName==='PDMSExecutive'  
                        || roleName==='AcademicSectionOfficer' || roleName === 'RTISectionOfficer' || roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnAssistantSectionOfficer' || roleName==='PDMSSectionOfficer' || roleName==='AFSectionOfficer' || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSectionOfficer'
                        ||roleName==='Accountant'||roleName==='AcademicAssistantSectionOfficer' ||roleName==='PDMSAssistantSectionOfficer' || roleName === 'ARPMAssistantSectionOfficer' || roleName==='ARPMSecExecutive' || roleName === 'RTIAssistantSectionOfficer' || roleName === 'AEAssistantSectionOfficer' ||roleName==='LegalExecutive'
                        ||roleName==='LegalAssistantSectionOfficer'||roleName==='AESectionofficer'|| roleName==='AEExecutive'||roleName==='AESectionofficer' ||roleName==='AFAssistantSectionOfficer'|| roleName ==='AEAssistantSecretary'||roleName ==='AcademicAsstSecty'||roleName==='ARPMAsstSecty'||roleName==='PDMSAsstSecty'||roleName ==='AdmsnAsstSecty'))">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="inbound/sectionexecutive/dashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Receipt Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionexecutive/trackDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Receipt</span>
                    </a>
                </li>

                <li *ngIf="previlizesList.includes('Create Dispatch Note Sheet')">
                    <a routerLink="outbound/se/createNoteSheet/0" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Put Up Note Sheet</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/dashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Note Sheet Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/trackNotesheetSecExec" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Note Sheet</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/correctionList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Correct Note Sheet</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/se/dispatchDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Dispatch Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionexecutive/otherSecDispatches" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Other Section Dispatches </span>
                    </a>
                </li>

                <li>
                    <a routerLink="outbound/se/secExeClarificationList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Received from Other Section(s) </span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Quaterly Report')">
                    <a routerLink="outbound/quaterlyReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Quaterly Report</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionexecutive/acknowledgementDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Acknowledgement Dashboard </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/diarydakreport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>File Directory</span>

                    </a>
                </li>
                <!-- seekapproval  major correction view check privileges -->
            </ul>
        </div>
    </li>
    <!-- SSA -->

    <!--INSPECTION SECTIONOFFICER -->
    <!-- SO  -->
    <li class="nav-item"
        *ngIf="((router.url.includes('inbound/'))||(router.url.includes('outbound/')) ||(router.url.includes('outbound/se/')))&& (roleName==='InspAsstSecty'|| roleName==='MSAsstSecty')">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="inbound/sectionincharge/receiptDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Receipt Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionincharge/trackReceiptDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Receipt </span>

                    </a>
                </li>
             
                <li *ngIf="previlizesList.includes('Create Dispatch Note Sheet')">
                    <a routerLink="outbound/se/createNoteSheet/0" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Put Up Note Sheet</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Section Officer Dispatch Dashboard')">
                    <a routerLink="outbound/secInch/IncDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Note Sheet Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/secInch/trackNotesheet" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track Note Sheet</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/secInch/correctionList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Correct Note Sheet</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Section Officer Dispatch Dashboard')">
                    <a routerLink="outbound/secInch/secInchDispatchDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Dispatch Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/sectionincharge/acknDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Acknowledgement Dashboard </span>

                    </a>
                </li>
                <!-- Print and seek approval major corretion and view check privileges -->
                <li>
                    <a routerLink="inbound/sectionincharge/OtherSecDispatch" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Other Section Dispatches </span>
                    </a>
                </li>

                <li>
                    <a routerLink="outbound/secInch/sectionClarification" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Received from Other Section(s) </span>
                    </a>
                </li>
                <li>
                    <a routerLink="inbound/diarydakincharge/diarydakreport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>File Directory</span>

                    </a>
                </li>

            </ul>
        </div>
    </li>
    <!-- SO  -->
    <!-- INSPECTION SECTIONOFFICER -->
    <!-- JSA -->
    <li class="nav-item"
        *ngIf="((router.url.includes('outbound/')) ||(router.url.includes('outbound/jsa/')))&& (roleName==='Junior Secretariat Assistant')">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="outbound/jsa/dash" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Dashboard</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Create Dispatch Note Sheet')">
                    <a routerLink="outbound/jsa/createNoteSheet" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Create Note Sheet/Letter</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>
    <!-- JSA -->

    <!-- President -->
    <li class="nav-item"
        *ngIf="(router.url.includes('outbound/diarydaksechead')) && (roleName==='DAK_Section_Executive')">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Diary Dak</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li *ngIf="previlizesList.includes('Dak Section Despatch Dashboard')">
                    <a routerLink="outbound/diarydaksechead/dashboard" routerLinkActive="active">
                        <img src="./../../../../assets/dashboard.png">
                        <span> Dashboard</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>
    <!-- College Module -->
    <!-- Student Admission Module -->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/college/dean'))&& (roleName==='College Principal' || roleName === 'AdmsnSectionOfficer' 
                || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnIncharge' 
                || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive')">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Student Admission</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li *ngIf="roleName === 'College Principal'">
                    <a routerLink="college/dean/studentsList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student List</span>
                    </a>
                </li>
                <li
                    *ngIf="previlizesList.includes('Student Admission') && (showAddStudentBDS || showAddStudentMDS || roleName === 'AdmsnSectionOfficer' 
                        || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnIncharge' 
                        || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive')">
                    <a (click)="addNewStudent()" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span> Add New Student</span>
                    </a>
                </li>
                <!-- <li>
                                        <a routerLink="college/dean/clarificationList" routerLinkActive="active">
                                            <i class="fas fa-angle-right sidenavIcon"></i>
                                            <span>Clarification List</span>
                                        </a>
                                    </li> -->

                <!-- Hide -->
                <!-- <li>
                            <a routerLink="college/dean/approveStudentsList" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Active Students</span>
                            </a>
                        </li>
                        <li>
                            <a routerLink="college/dean/dischargeStudentsList" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Students Discharged List</span>
                            </a>
                        </li> -->
            </ul>
        </div>
    </li>
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/college/admissionMonitorCellExecutive'))&& (roleName==='Student Admission Executive' || roleName==='AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer'
       || roleName==='President UG-PG'|| roleName === 'UGPG-DEB' || roleName==='AdmsnSecExecutive' || roleName === 'AdmsnIncharge' || roleName === 'AdmsnAsstSecty' || roleName === 'System Admin' || roleName === 'ServerSecExecutive')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Student Admission</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="college/admissionMonitorCellExecutive/collegelist" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>List of Colleges</span>
                    </a>
                </li>
                <li>
                    <a *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewStudentsList'))">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Students For The College</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/admissionMonitorCellExecutive/studentSearch" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Search</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/admissionMonitorCellExecutive/collegeSearch" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>College Search</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/admissionMonitorCellExecutive/collegeOfferedSpec" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>College Offered Course Spec</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Student Admission Period') && (roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnAsstSecty' 
                    || roleName === 'AdmsnIncharge' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName==='President UG-PG' ||  roleName === 'UGPG-DEB')">
                    <a routerLink="college/admissionMonitorCellExecutive/admissionPeriod" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Admission Period</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Student Passing Criteria') && (roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnAsstSecty' 
                || roleName === 'AdmsnIncharge' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName==='President UG-PG' || roleName === 'UGPG-DEB')">
                    <a routerLink="college/admissionMonitorCellExecutive/criteriaList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Passing Criteria</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Note Sheet Subject/Contents') && (roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnAsstSecty' 
                    || roleName === 'AdmsnIncharge' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName==='President UG-PG' ||  roleName === 'UGPG-DEB')">
                        <a routerLink="college/admissionMonitorCellExecutive/noteSheetContentList" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Note Sheet Subject/Contents</span>
                    </a>
                </li> 
                <li *ngIf="previlizesList.includes('Permitted/Admitted/Vacant Seats') && (roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnAsstSecty' 
                || roleName === 'AdmsnIncharge' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName==='President UG-PG' || roleName === 'UGPG-DEB')">
                    <a routerLink="college/admissionMonitorCellExecutive/seatsReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Permitted/Admitted/Vacant Seats</span>
                    </a>
                </li>
                <!-- <li *ngIf="previlizesList.includes('Permitted/Admitted/Vacant Seats') && (roleName === 'AdmsnSectionOfficer' || roleName === 'AdmsnAssistantSectionOfficer' || roleName === 'AdmsnSecExecutive' || roleName === 'AdmsnAsstSecty' 
                || roleName === 'AdmsnIncharge' || roleName === 'System Admin' || roleName === 'ServerSecExecutive' || roleName==='President UG-PG' || roleName === 'UGPG-DEB')">
                    <a routerLink="college/admissionMonitorCellExecutive/studentReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Report Details</span>
                    </a>
                </li> -->

                 <li>
                        <a routerLink="college/admissionMonitorCellExecutive/counsellingMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Counselling Authority Master</span>
                        </a>
                    </li>
                 <li>
                        <a routerLink="college/admissionMonitorCellExecutive/universityMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>University Master</span>
                        </a>
                    </li>   
                
            </ul>
        </div>
    </li>
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/college/admissionMonitorCellExecutive'))&& (roleName==='UGPG Consultant')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Student Admission</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="college/admissionMonitorCellExecutive/collegelist" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>List of Colleges</span>
                    </a>
                </li>
                <li>
                    <a *ngIf="(router.url.includes('college/admissionMonitorCellExecutive/viewStudentsList'))">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Students For The College</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/admissionMonitorCellExecutive/studentSearch" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Search</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/admissionMonitorCellExecutive/collegeSearch" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>College Search</span>
                    </a>
                </li>
                
                <li *ngIf="previlizesList.includes('Student Admission Period') && (roleName==='UGPG Consultant')">
                    <a routerLink="college/admissionMonitorCellExecutive/admissionPeriod" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Admission Period</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Student Passing Criteria') && ( roleName==='UGPG Consultant')">
                    <a routerLink="college/admissionMonitorCellExecutive/criteriaList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Passing Criteria</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Note Sheet Subject/Contents') && ( roleName==='UGPG Consultant')">
                        <a routerLink="college/admissionMonitorCellExecutive/noteSheetContentList" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Note Sheet Subject/Contents</span>
                    </a>
                </li> 
                <li *ngIf="previlizesList.includes('Permitted/Admitted/Vacant Seats') && (roleName==='UGPG Consultant')">
                    <a routerLink="college/admissionMonitorCellExecutive/seatsReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Permitted/Admitted/Vacant Seats</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Permitted/Admitted/Vacant Seats') && ( roleName==='UGPG Consultant')">
                    <a routerLink="college/admissionMonitorCellExecutive/studentReport" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Report Details</span>
                    </a>
                </li>

                 <li>
                        <a routerLink="college/admissionMonitorCellExecutive/counsellingMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Counselling Authority Master</span>
                        </a>
                    </li>
                 <li>
                        <a routerLink="college/admissionMonitorCellExecutive/universityMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>University Master</span>
                        </a>
                    </li>   
                
            </ul>
        </div>
    </li>
     <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/college/admissionMonitorCellExecutive'))&& (roleName==='CA'|| roleName==='University')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Student Admission</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                
                <li *ngIf="(roleName === 'CA'|| roleName === 'University')">
                    <a routerLink="college/admissionMonitorCellExecutive/studentAdmissionDetails" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Admission Details</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>
    <!-- <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/college/feecollectiondetails/'))&& (this.roleName === 'AFSecInCharge' || roleName === 'College Principal')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Fee Collection</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li *ngIf="roleName === 'AFSecInCharge'">
                    <a routerLink="college/feecollectiondetails/feecollection" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>List of Colleges</span>
                    </a>
                </li>
                <li *ngIf="roleName === 'College Principal' ">
                    <a routerLink="college/feecollectiondetails/viewFeeList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>List of Payment</span>
                    </a>
                </li>
            </ul>
        </div>
    </li> -->

    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/college/executiveCommittee'))&& (roleName==='Stu Executive Commitee')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Student Admission</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="college/executiveCommittee/dashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Agenda Dashboard</span>
                    </a>
                </li>


            </ul>
        </div>
    </li>
    <!-- Student Admission Module -->
    <!-- Course Completion -->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/college/collegeRep'))&& (roleName==='College Principal')">
        <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Student Course Progression</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="college/collegeRep/coursecompletionStudentList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Promote a Student</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/collegeRep/coursecompletionForm" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Complete Course of a Student</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>

    <li *ngIf="router.url.includes('main/internal/eligibility/') && (roleName === 'PDMSSecInCharge' 
    || roleName === 'PDMSAsstSecty' || roleName === 'PDMSSectionOfficer' || roleName === 'PDMSAssistantSectionOfficer' || roleName === 'PDMSExecutive')">
        <a routerLinkActive="active">
            <img src="./../../../assets/dashboard.png">
            <span>Eligibility </span>
        </a>
        <a routerLink="eligibility/secDashboard" routerLinkActive="active">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Eligibility Certificate Application</span>
        </a>
        <a routerLink="eligibility/secTrackDashboard" routerLinkActive="active">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Track Eligibility Certificate Application</span>
        </a>
    </li>
    <!-- For Eligiblity by gokul  -->
    <li *ngIf=" router.url.includes('main/internal/eligibility/') && roleName === 'Student'">
        <!-- Eligiblity Certiicate Module Starts-->
        <a routerLink="../internal/dashboard" routerLinkActive="inactive">
            <img src="./../../../assets/dashboard.png">
            <span>Home </span>
        </a>
        <a routerLink="eligibility/dashboard/0" routerLinkActive="active">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Eligibility Certificate Applications</span>
        </a>
        <a routerLink="eligibility/raisenewrequest" routerLinkActive="active">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Raise a new request</span>
        </a>
    </li>
    <!-- Eligiblity Certiicate Module Ends-->

    <!-- FQSR Certiicate Module Starts-->
    <li class="nav-item" *ngIf="(router.url.includes('main/internal/fqsr/')) && (roleName === 'Student' || roleName === 'PDMSSecInCharge' 
    || roleName === 'PDMSAsstSecty' || roleName === 'PDMSSectionOfficer' || roleName === 'PDMSAssistantSectionOfficer' 
    || roleName === 'PDMSExecutive')">     
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>FQSR</span></a>
            <div class="collapse show" id="submenu1" aria-expanded="false" *ngIf="roleName === 'Student'">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="fqsr/dashboard/0" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>FQSR Dashboard</span>
                        </a>
                    </li>
                    <!-- <li *ngIf="showFqsrRequest"> -->
                        <li>
                        <a routerLink="fqsr/instructions" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Raise a FQSR Request</span>
                        </a>
                    </li>
                </ul>
            </div>
            
            <div class="collapse show" id="submenu1" aria-expanded="false"
                *ngIf="roleName === 'PDMSSecInCharge' || roleName === 'PDMSAsstSecty' || roleName === 'PDMSSectionOfficer' 
                || roleName === 'PDMSAssistantSectionOfficer' || roleName === 'PDMSExecutive'">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="fqsr/secDashboard" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>FQSR Dashboard</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="fqsr/secTrackDashboard" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>FQSR Track Dashboard</span>
                        </a>
                    </li>
                </ul>
            </div>
    </li>
    <!-- FQSR Certiicate Module Ends By Kannan-->

    <!--PTR Module Starts-->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/ptr/')) && (roleName==='PTR' || roleName==='College Principal')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>PTR</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="ptr/dashboard/0" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>PTR Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="ptr/editPTR/0" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>New PTR Application</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>

    <li class="nav-item" *ngIf="(router.url.includes('main/internal/ptr/')) && (roleName === 'PDMSSecInCharge' || roleName==='PDMSAsstSecty' 
    || roleName==='PDMSSectionOfficer' || roleName==='PDMSAssistantSectionOfficer' || roleName==='PDMSExecutive')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>PTR</span></a>
        <div class="collapse show" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">

                <li *ngIf="(roleName==='PDMSSecInCharge')">
                    <a routerLink="ptr/sectionHead/secHeadPtrDashBoard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>PTR Dashboard</span>
                    </a>
                </li>

                <li *ngIf="(roleName==='PDMSAsstSecty' 
                || roleName==='PDMSSectionOfficer' || roleName==='PDMSAssistantSectionOfficer' || roleName==='PDMSExecutive')">
                    <a routerLink="ptr/sectionExcutive/secExePtrDashBoard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>PTR Dashboard</span>
                    </a>
                </li>
                <li *ngIf="(roleName === 'PDMSSecInCharge' || roleName==='PDMSAsstSecty' 
                || roleName==='PDMSSectionOfficer' || roleName==='PDMSAssistantSectionOfficer' || roleName==='PDMSExecutive')">
                    <a routerLink="ptr/ptrCommon/trackPtrDashBoard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Track PTR Dashboard</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>

    <!-- <li class="nav-item"
            *ngIf="(router.url.includes('main/internal/ptrCollege/')) && (roleName==='College Principal')">
            <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse"
                data-target="#submenu2">
                <img src="./../../../assets/My-Grievances-Status.png">
                <span>PTR</span></a>
            <div class="collapse show" id="submenu2" aria-expanded="false">
                <ul class="flex-column  nav">        
                    <li>
                        <a routerLink="collegeDashboard" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>PTR Dashboard</span>
                        </a>
                    </li>               
                    <li>
                        <a routerLink="editPTR/0" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>New PTR Application</span>
                        </a>
                    </li>
                    </ul>
                </div>
            </li> -->
    <!-- PTR Certiicate Module Ends By SUGAND-->

    <!-- Anti-Ragging By Riyaz ====  College Principle  -->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/antiRagging')) && roleName === 'College Principal'">

        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Anti-Ragging</span></a>

        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="antiRagging/antiRaggingDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Add Anti-Ragging Report</span>
                    </a>
                </li>
                <li>
                    <a routerLink="antiRagging/antiRaggingList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Anti-Ragging DashBoard</span>
                    </a>
                </li>
                <!-- <li>
                            <a routerLink="antiRagging/antiRaggingView/:antiRaggingId" routerLinkActive="active">
                                <i class="fas fa-angle-right sidenavIcon"></i>
                                <span>Anti-Ragging View</span>
                            </a>
                        </li> -->
            </ul>
        </div>
    </li>

    <!-- Anti-Ragging By Riyaz === ARPMSecInCharge -->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/antiRagging')||router.url.includes('main/internal/orientationProgram')) && (roleName === 'ARPMSecInCharge' || roleName === 'ARPMAsstSecty' || roleName === 'ARPMAssistantSectionOfficer' ||  roleName === 'ARPMSecExecutive' || roleName === 'System Admin'||  roleName === 'ServerSecExecutive')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Anti-Ragging</span></a>
        <div class="collapse show" id="submenu1" aria-expanded="false">
            <ul class="flex-column  nav">
                <li *ngIf="previlizesList.includes('Anti-Ragging')">
                    <a routerLink="antiRagging/sectionantiRaggingDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Anti-Ragging Dashboard</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Anti-Ragging')">
                    <a routerLink="antiRagging/sectionantiRaggingList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Anti-Ragging List</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Anti-Ragging Orientation Program')">
                    <a routerLink="orientationProgram/antiRaggingOrientationDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Anti-Ragging Orientation Program DashBoard</span>
                    </a>
                </li>
                <li *ngIf="previlizesList.includes('Anti-Ragging Orientation Program')">
                    <a routerLink="orientationProgram/secAntiRaggingOrientationProgramList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Anti-Ragging Orientation Program List</span>
                    </a>
                </li>
            </ul>
        </div>

    </li>

    <!-- Anti-Ragging End -->

    <!-- Audit Log Start -->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/auditLog'))  && (roleName==='System Admin' || roleName === 'ServerSecExecutive')">
        <a class="nav-link collapsed text-truncate" data-toggle="collapse" data-target="#submenu5">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Audit Log</span></a>
        <div class="collapse show" id="submenu5" aria-expanded="false">
    <li class="nav-item">
        <a class="nav-link collapsed text-truncate" routerLink="auditLog/dashboard" routerLinkActive="active">
            <img src="./../../../assets/dashboard.png">
            <span>Audit Log Dashboard</span></a>
    </li>
    </div>
    </li>
    <!-- Audit Log End -->




    <!--  MDM  start-->

    <!-- Common Master (MDM) start -->

    <li class="nav-item" *ngIf="(router.url.includes('main/internal/mdm'))">
        <a class="nav-link collapsed text-truncate" href="#submenu" data-toggle="collapse" data-target="#submenu">
            <img src="./../../../assets/dashboard.png">
            <span>MDM </span>
        </a>
        <!-- class="collapse navbar-collapse -->
        <div class="collapse show" id="submenu" aria-expanded="true">
            <a class="nav-link collapsed text-truncate" href="#submenu1" data-toggle="collapse" data-target="#submenu1">
                <img src="./../../../assets/My-Grievances-Status.png">
                <span>Common</span></a>
            <div class="collapse show" id="submenu1" aria-expanded="false">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="mdm/common/countryMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Country Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/stateMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>State Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/cityMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>City Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/courseMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Course Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/specialisationMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Specialisation Master</span>
                        </a>
                    </li>
                    <li>
                        <a (click)="ministry()" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Ministry</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/employeesMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>DCI Officers/Employees</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/collegeMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>College Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/dmeMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>DME Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/healthSecretaryMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Health Secretary Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/sdcMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>SDC Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/advocateMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Advocate Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/universityMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>University Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/ecMemberMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>EC Member Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/gbMemberMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>GB Member Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/counsellingAuthorityMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Counselling Authority Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/designationMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Designation Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/departmentMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Department Master</span>
                        </a>
                    </li>             
                    <li>
                        <a routerLink="mdm/common/dentistMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Dentist Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/staffTypeMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Staff Category Master</span>
                        </a>
                    </li>      
                    <li>
                        <a routerLink="mdm/common/staffMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Staff Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/common/stateBoardMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>State Board Master</span>
                        </a>
                    </li>

                    <li>
                        <a routerLink="mdm/common/paymentTest" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Payment Test</span>
                        </a>
                    </li>

                </ul>
            </div>
            <!-- Common Master (MDM) end -->
            <!-- legal start (mdm)-->
            <!-- <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse"
                data-target="#submenu2">
                <img src="./../../../assets/My-Grievances-Status.png">
                <span>Masters</span></a>
            <div class="collapse navbar-collapse" id="submenu2" aria-expanded="true">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="mdm/legal/courtMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Court Master</span>
                        </a>
                    </li>
                   
                    <li>
                        <a routerLink="mdm/legal/advocateMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Advocate Master</span>
                        </a>
                    </li>

                    <li>
                        <a routerLink="mdm/legal/advocateCategory" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Advocate Category</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/legal/caseCategoryMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Case Category Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/legal/caseTypeMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Case Type Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/legal/fileMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>File Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/legal/advocateFeeMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Advocate Fee Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/legal/documnetTemplateMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Document Template Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/legal/caseToDoListMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Case To do List Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/legal/documentTypeMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Document Type Master</span>
                        </a>
                    </li> -->


            <!-- start comd <li>
                        <a routerLink="mdm/legal/courtBenchMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Court Bench Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="mdm/legal/courtTypeMaster" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Court Type Master </span>
                        </a>
                    </li> -->

            <!-- <li>
                        <a routerLink="mdm/legal/caseFileManagement" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Case File Management </span>
                        </a>
                    </li> -->
            <!-- <li>
                        <a routerLink="mdm/legal/advocateCourtMapping" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Advocate Court Mapping </span>
                        </a>
                    </li> -->
            <!-- <li>
                        <a routerLink="mdm/legal/caseToDoListMapping" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Case To Do List Mapping </span>
                        </a>
                    </li> -->

            <!-- </ul>
            </div> -->
        </div>
    </li>

    <!-- legal end (mdm)-->
    <!-- MDM End-->

    <!-- Legal Master Start-->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
|| roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">
        <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu2">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Master</span></a>
        <div class="collapse navbar-collapse" id="submenu2" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="legal/courtMaster">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Court Master</span>
                    </a>
                </li>
                <li>
                    <a routerLink="legal/advocateMaster">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Advocate Master</span>
                    </a>
                </li>
                <li>
                    <a routerLink="legal/advocateCategory">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Advocate Category</span>
                    </a>
                </li>
                <li>
                    <a routerLink="legal/caseCategoryMaster">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Case Category Master</span>
                    </a>
                </li>
                <li>
                    <a routerLink="legal/caseTypeMaster">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Case Type Master</span>
                    </a>
                </li>
                <!-- <li>
                        <a routerLink="legal/fileMaster">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>File Master</span>
                        </a>
                    </li> -->
                <!-- <li>
                        <a routerLink="legal/advocateFeeMaster">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Advocate Fee Master</span>
                        </a>
                    </li> -->
                <li>
                    <a routerLink="legal/documnetTemplateMaster">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Document Template Master</span>
                    </a>
                </li>
                <!-- <li>
                        <a routerLink="legal/caseToDoListMaster">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Case To do List Master</span>
                        </a>
                    </li> -->
                <!-- <li>
                        <a routerLink="legal/documentTypeMaster">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Document Type Master</span>
                        </a>
                    </li> -->
                <!-- <li>
                        <a routerLink="legal/courtBenchMaster">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Court Bench Master</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="legal/courtTypeMaster">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Court Type Master </span>
                        </a>
                    </li> -->


            </ul>
        </div>
    </li>


    <!-- Legal Master End -->
    <!-- Legal Mapping -->
    <!-- <li class="nav-item" *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
|| roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">
    <a class="nav-link collapsed text-truncate" data-toggle="collapse" data-target="#submenu6">
        <img src="./../../../assets/My-Grievances-Status.png">
        <span>Mapping </span></a>
    <div class="collapse navbar-collapse" id="submenu6" aria-expanded="true">
        <li>
            <a routerLink="legal/advocatecourtmapping">
                <i class="fas fa-angle-right sidenavIcon"></i>
                <span>Advocate Court Mapping</span>
            </a>
        </li> 

        <li>
            <a routerLink="legal/caseToDoListMapping">
                <i class="fas fa-angle-right sidenavIcon"></i>
                <span>Case To Do List Mapping</span>
            </a>
        </li> 
        
        <li>
            <a routerLink="legal/taggingConnectedCasesInACourt" routerLinkActive="active">
                <i class="fas fa-angle-right sidenavIcon"></i>
                <span>Tagging Connected Cases In A Court</span>
            </a>
        </li>
    </div>
</li> -->
    <!-- END -->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
|| roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">

        <a routerLink="legal/caseFileManagement" routerLinkActive="active">
            <span>Case File Management</span>
        </a>

    </li>

    <!-- <li class="nav-item" *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
    || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">
      
            <a routerLink="legal/assignChangeAdvocate">
                <span>Assign Advocate</span>
            </a>

        </li> -->
    <!-- <li class="nav-item" *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
        || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">
           
            <a routerLink="legal/counterReplyAffidavit">
                <span>Counter Reply Affidavit</span>
            </a>
       
        </li> -->
    <!-- <li class="nav-item" *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
        || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">
          
            <a routerLink="legal/changeAdvocate">
                <span>Change Advocate</span>
            </a>
      
        </li> -->
    <!-- <li class="nav-item" *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
        || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">
        
            <a routerLink="legal/advocateInvoiceSubmission" routerLinkActive="active">
                <span>Advocate Invoice Submission</span>
            </a>
       
        </li> -->
    <!-- <li class="nav-item" *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
        || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">
     
            <a routerLink="legal/dciAdvocateCommunication" routerLinkActive="active">
                <span>DCI V/S Advocate Communication</span>
            </a>
       
        </li> -->
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
        || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">

        <a routerLink="legal/queriesReports" routerLinkActive="active">
            <span>Reports</span>
        </a>

    </li>
    <li class="nav-item"
        *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='LegalExecutive' || roleName==='LegalSectionOfficer'
        || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSecInCharge' || roleName==='LegalAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')">

        <a routerLink="legal/documentRepository" routerLinkActive="active">
            <span>Document Repository</span>
        </a>

    </li>


    <!-- Legal Mapping End -->


    <!--ADD by GOKUL darkDairy File Structure-->
    <li class="nav-item"
        *ngIf="((router.url.includes('outbound/secInch/'))||(router.url.includes('inbound/'))||(router.url.includes('outbound/')))&& ((roleName==='AFSecInCharge' ||
            roleName==='AdmsnIncharge' || roleName==='AcademicIncharge' ||roleName==='LegalSecInCharge'||roleName==='AEIncharge' 
            ||roleName==='ISecInCharge' ||roleName==='RTISecInCharge' || roleName==='ServerSecInCharge' ||roleName ==='ARPMSecInCharge'
            ||roleName ==='PDMSSecInCharge'||roleName==='InspAsstSecty' || roleName==='MSAsstSecty' || roleName==='AFExecutive' || roleName==='RTIExecutive'|| roleName==='AcademicExecutive' || roleName==='ServerSecExecutive' || roleName==='PDMSExecutive'  
            || roleName==='AcademicSectionOfficer' || roleName === 'RTISectionOfficer' || roleName === 'AdmsnSectionOfficer' ||  roleName === 'AdmsnSecExecutive'  || roleName === 'AdmsnAssistantSectionOfficer' || roleName==='PDMSSectionOfficer'  || roleName==='AFSectionOfficer' || roleName==='LegalRetainer' || roleName==='RTILegalRetainer' || roleName==='LegalSectionOfficer'
            ||roleName==='Accountant'||roleName==='AcademicAssistantSectionOfficer' ||roleName==='PDMSAssistantSectionOfficer' || roleName === 'ARPMAssistantSectionOfficer' || roleName==='ARPMSecExecutive' || roleName === 'RTIAssistantSectionOfficer' || roleName === 'AEAssistantSectionOfficer' ||roleName==='LegalExecutive'
            ||roleName==='LegalAssistantSectionOfficer'||roleName==='AESectionofficer'|| roleName==='AEExecutive'||roleName==='AESectionofficer' ||roleName==='AFAssistantSectionOfficer'|| roleName ==='AEAssistantSecretary'||roleName ==='AcademicAsstSecty'||roleName==='ARPMAsstSecty'||roleName==='PDMSAsstSecty'||roleName ==='AdmsnAsstSecty'))">
        <a class="nav-link collapsed text-truncate" href="#submenu7" data-toggle="collapse" data-target="#submenu7">
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>File Structure</span></a>
        <div class="collapse navbar-collapse" id="submenu7" aria-expanded="false">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="outbound/secInch/fileStructureSubCategory" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Add SubCategory</span>
                    </a>
                </li>
                <li>
                    <a routerLink="outbound/secInch/fileStructureFileReference" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Add File Reference</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>

    <!--Added for Self Assessment Report-->
    <li class="nav-item" *ngIf="router.url.includes('college/collegeProfile/') && (roleName ==='College Principal' || roleName === 'College Representative')">
        <a class="nav-link collapsed text-truncate" href="#submenu7" data-toggle="collapse" data-target="#submenu7">
            <img src="./../../../assets/dashboard.png">
            <span>Self Assessment</span></a>
        <div class="collapse show" id="submenu7" aria-expanded="true">
            <ul class="flex-column  nav">
                <li>
                    <a routerLink="college/collegeProfile/collegeDashboard" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>College Dashboard</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/collegeProfile/generalInformation" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>General Information</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/collegeProfile/bankDetails" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Bank Details</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/collegeProfile/constructionPlanning" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Construction / Planning</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/collegeProfile/attachedHospital" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Attached Hospital Detail + <span style="padding-left: 10%;">Clinical Workload
                            </span></span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/collegeProfile/equipment" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Equipment</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/collegeProfile/infrastructureList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Infrastructure</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/collegeProfile/centralLibrary" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Central Library + Department <span style="padding-left: 10%;">Library</span></span>
                    </a>
                </li>
                <!-- <li>
        <a routerLink="college/collegeProfile/collegeStaffList" routerLinkActive="active">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Dental College Staff / Manpower <span style="padding-left: 10%;">With Publication </span> </span>
        </a>
       </li>                   -->
                <li>
                    <a href="#submenu8" data-toggle="collapse" data-target="#submenu8">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Dental College Staff / Manpower <span style="padding-left: 10%;">With Publication </span>
                        </span></a>
                    <div class="collapse hide" id="submenu8" aria-expanded="true">
                        <ul class="flex-column  nav" style="padding-bottom: 0%;">
                            <li style="padding-left: 5%;">
                                <a routerLink="college/collegeProfile/collegeStaffList" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Dental Teaching Staff</span>
                                </a>
                            </li>
                            <li style="padding-left: 5%;">
                                <a routerLink="college/collegeProfile/medicalTeachingStaffList"
                                    routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Medical Teaching Staff</span>
                                </a>
                            </li>
                            <li style="padding-left: 5%;">
                                <a routerLink="college/collegeProfile/nonTeachingStaffList" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Non-Teaching Staff</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>

                <li *ngIf="collegeDetails?.mdsCourse">
                    <a routerLink="college/collegeProfile/studentAcademic" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Academic Presentation</span>
                    </a>
                </li>
                <li *ngIf="collegeDetails?.mdsCourse">
                    <a routerLink="college/collegeProfile/teachingLearning" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Teaching/Learning Activities</span>
                    </a>
                </li>
                <li *ngIf="roleName==='College Principal'">
                    <a routerLink="college/collegeProfile/submitselfassesment" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Submit Self Assessment</span>
                    </a>
                </li>
                <!-- <li>
        <a routerLink="college/collegeProfile/studentAcademic" routerLinkActive="active">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Student Academic Presentation + <span style="padding-left: 10%;">Teaching/Learning Activities </span></span>
        </a>
       </li> -->
                <!-- <li>
        <a href="#submenu9" data-toggle="collapse"
            data-target="#submenu9">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Student Academic Presentation + <span style="padding-left: 10%;">Teaching/Learning Activities </span></span></a>
            <div class="collapse show" id="submenu9" aria-expanded="true">
                <ul class="flex-column  nav">
                    <li>
                        <a routerLink="college/collegeProfile/studentAcademic" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Student Academic Presentation</span>
                        </a>
                    </li>
                    <li>
                        <a routerLink="college/collegeProfile/teachingLearning" routerLinkActive="active">
                            <i class="fas fa-angle-right sidenavIcon"></i>
                            <span>Teaching/Learning Activities</span>
                        </a>
                    </li>
                </ul>
            </div>
        </li> -->
            </ul>
        </div>
    </li>

    <!-- SAR View -->
    <li class="nav-item"
        *ngIf="router.url.includes('college/viewSar')  && ((roleName==='AcademicIncharge' || roleName==='AcademicAsstSecty' || roleName==='AcademicAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin')
        ||  (roleName==='College Principal' || roleName === 'College Representative' 
        || ( collegeId !== null && collegeId !== '' && collegeId !== undefined)))">
        <a class="nav-link collapsed text-truncate" href="#submenu7" data-toggle="collapse" data-target="#submenu7">
            <img src="./../../../assets/dashboard.png">
            <span>Self Assessment Report</span></a>
        <div class="collapse show" id="submenu7" aria-expanded="true">
            <ul class="flex-column nav">
                <li *ngIf="roleName==='AcademicIncharge' || roleName==='AcademicAsstSecty' || roleName==='AcademicAssistantSectionOfficer' || roleName==='ServerSecExecutive' || roleName==='System Admin'">
                    <a routerLink="college/viewSar/collegeList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>College List</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/viewSar/generalInformation" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>General Information</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/viewSar/bankDetails" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Bank Details</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/viewSar/constructionPlanning" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Construction / Planning</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/viewSar/attachedHospital" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Attached Hospital Detail + <span style="padding-left: 10%;">Clinical Workload
                            </span></span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/viewSar/equipment" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Equipment</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/viewSar/infrastructureList" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Infrastructure</span>
                    </a>
                </li>
                <li>
                    <a routerLink="college/viewSar/centralLibrary" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Central Library + Department <span style="padding-left: 10%;">Library</span></span>
                    </a>
                </li>
                <li>
                    <a href="#submenu8" data-toggle="collapse" data-target="#submenu8">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Dental College Staff / Manpower <span style="padding-left: 10%;">With Publication </span>
                        </span></a>
                    <div class="collapse hide" id="submenu8" aria-expanded="true">
                        <ul class="flex-column  nav" style="padding-bottom: 0%;">
                            <li style="padding-left: 5%;">
                                <a routerLink="college/viewSar/collegeStaffList" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Dental Teaching Staff</span>
                                </a>
                            </li>
                            <li style="padding-left: 5%;">
                                <a routerLink="college/viewSar/medicalTeachingStaffList" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Medical Teaching Staff</span>
                                </a>
                            </li>
                            <li style="padding-left: 5%;">
                                <a routerLink="college/viewSar/nonTeachingStaffList" routerLinkActive="active">
                                    <i class="fas fa-angle-right sidenavIcon"></i>
                                    <span>Non-Teaching Staff</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>

                <li *ngIf="collegeDetails?.mdsCourse">
                    <a routerLink="college/viewSar/studentAcademic" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Student Academic Presentation</span>
                    </a>
                </li>
                <li *ngIf="collegeDetails?.mdsCourse">
                    <a routerLink="college/viewSar/teachingLearning" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Teaching/Learning Activities</span>
                    </a>
                </li>
                <li *ngIf="roleName==='College Principal'">
                    <a routerLink="college/viewSar/submitselfassesment" routerLinkActive="active">
                        <i class="fas fa-angle-right sidenavIcon"></i>
                        <span>Submit Self Assessment</span>
                    </a>
                </li>
            </ul>
        </div>
    </li>

    <!-- Legal Advocate -->

    <li class="nav-item" *ngIf="(router.url.includes('main/internal/legal'))  && (roleName==='Advocate')">
        <a>
            <img src="./../../../assets/My-Grievances-Status.png">
            <span>Advocate Dashboard </span></a>
        <div>
    <li>
        <a (click)="profileClick()">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Profile</span>
        </a>
    </li>
    <li *ngIf="access">
        <a routerLink="legal/AdvocateAssignedCasesComponent">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Assigned Cases</span>
        </a>
    </li>
    <!-- <li  *ngIf="access">
            <a routerLink="legal/AdvocateCommunicationComponent" routerLinkActive="active">
                <i class="fas fa-angle-right sidenavIcon"></i>
                <span>Communication With DCI</span>
            </a>
        </li>
        <li  *ngIf="access">
            <a routerLink="legal/AdvocateUserInvoiceSubmissionComponent" routerLinkActive="active">
                <i class="fas fa-angle-right sidenavIcon"></i>
                <span>Invoice Submission</span>
            </a>
        </li> -->
    <li *ngIf="access">
        <a routerLink="legal/AdvocateCommunicationDashboardComponent" routerLinkActive="active">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Communication With DCI</span>
        </a>
    </li>
    <li *ngIf="access">
        <a routerLink="legal/AdvocateUserInvoiceSubmissionDashboardComponent" routerLinkActive="active">
            <i class="fas fa-angle-right sidenavIcon"></i>
            <span>Invoice Submission</span>
        </a>
    </li>
    </div>
    </li>

    <!-- Legal Advocate End -->


     <!-- SLA Start -->
     <li class="nav-item"
     *ngIf="(router.url.includes('main/internal/sla'))  && (roleName =='System Admin'||roleName =='ServerSecExecutive')">
     <a class="nav-link collapsed text-truncate" data-toggle="collapse" data-target="#submenu155">
        <img src="./../../../assets/dashboard.png">
         <span>SLA</span></a>
     <div class="collapse show" id="submenu155" aria-expanded="false">
        <li class="nav-item">
            <a class="nav-link collapsed text-truncate" routerLink="sla/slaReportsDashboard" routerLinkActive="active">
                <i class="fas fa-angle-right sidenavIcon"></i>
                <span>SLA Reports Dashboard</span></a>
        </li>
        <li class="nav-item">
            <a class="nav-link collapsed text-truncate" routerLink="sla/exportSlaReport" routerLinkActive="active">
                <i class="fas fa-angle-right sidenavIcon"></i>
                <span>SLA Report</span></a>
        </li>
        <li class="nav-item">
            <a class="nav-link collapsed text-truncate" routerLink="sla/summary" routerLinkActive="active">
                <i class="fas fa-angle-right sidenavIcon"></i>
                <span>SLA </span></a>
        </li>
    </div>
    </li>


 <!-- Audit Log End -->
 <!-- Anti-Ragging Orientation Program  By Ishvarya ====  College Principle  -->
 <li class="nav-item"
 *ngIf="(router.url.includes('main/internal/orientationProgram')) && roleName === 'College Principal'">

 <!-- <a class="nav-link collapsed text-truncate" href="#submenu2" data-toggle="collapse" data-target="#submenu1">
     <img src="./../../../assets/My-Grievances-Status.png">
     <span>Anti-Ragging Orientation Program</span></a> -->

 <div class="collapse show" id="submenu1" aria-expanded="false">
     <ul class="flex-column  nav">      
         <li *ngIf="previlizesList.includes('Anti-Ragging Orientation Program')">
             <a routerLink="orientationProgram/antiRaggingOrientationProgramList" routerLinkActive="active">
                 <!-- <i class="fas fa-angle-right sidenavIcon"></i> -->
                 <img src="./../../../assets/My-Grievances-Status.png">
                 <span>Anti-Ragging Orientation <span style="padding-left: 10%;">Program DashBoard</span></span>
             </a>
         </li>
        </ul>
    </div>

</li>
    </ul>
    </div>
    </div>
    </nav>





    <!-- sidebar-wrapper  -->
    <main [ngClass]="(!router.url.includes('/excu/ec/caseitem'))?'page-content':'my-class3'">
        <div>

            <div class="row" style="margin-top:70px;">
                <div class="col-md-12">
                    <app-breadcrumb *ngIf="showBread"></app-breadcrumb>
                    <app-modal></app-modal>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>

    </main>
    <!-- page-content" -->
    </div>
</main>

<!-- The Modal -->
<div class="modal" id="roleModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Change Role</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body container">
                <div class="ng-container">
                    <div class="row">
                        <div class="col-md-6" *ngFor="let si of roleList">
                            <label for="enum_answer_{{si.roleName}}" style="cursor: pointer;width: 150%;">
                                <input id="enum_answer_{{si.roleName}}" [value]='si.roleName' (change)="roleSelected()"
                                    type="radio" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedRole">
                                {{si.roleName}}
                            </label>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>

        </div>
    </div>
</div>
<!-- Password Modal -->
<div class="modal" id="passwordModal" data-backdrop="static">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Change Password</h4>
                <button type="button" *ngIf="pwdStatus" class="close" data-dismiss="modal"
                    (click)="reset()">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body container">
                <div class="ng-container">
                    <form [formGroup]="changePasswordForm">
                        <div class="row">
                            <div class="col-md-6">
                                <label style="cursor: pointer;">Old Password : <span
                                        class="text-danger">*</span></label>
                            </div>
                            <div class="col-md-6">
                                <input [type]="showOldPassword ? 'text' : 'password'" class="form-control"
                                    placeholder="Old Password" formControlName="oldPwd">
                                <span (click)="eyeToggelForOldPassword()" class="eyeIcon"><i
                                        [ngClass]="eyeShowForOld ? 'fa fa-eye' : 'fa fa-eye-slash '" class="icon"
                                        aria-hidden="true"></i></span>
                                <div *ngIf="changePasswordForm.controls['oldPwd'].hasError('required') && changePasswordForm.controls['oldPwd'].touched"
                                    class="failed-validation" style="color:red;">
                                    Password Required
                                </div>
                                <!-- <div *ngIf="(changePasswordForm.controls['oldPwd'].hasError('passwordStrength'))" class="failed-validation" style="color:red">
                                Password must have One Upper,LowerCase,Alphabetic And Special Character
                            </div>
                            <div *ngIf="changePasswordForm.controls['oldPwd'].hasError('minlength')" class="failed-validation" style="color:red">
                                Password must have 8 characters
                            </div> -->
                            </div>


                        </div>
                        <br>
                        <div class="row">
                            <div class="col-md-6">
                                <label style="cursor: pointer;">New Password : <span
                                        class="text-danger">*</span></label>



                            </div>
                            <div class="col-md-6">
                                <input [type]="showNewPassword ? 'text' : 'password'" class="form-control"
                                    placeholder="New Password" formControlName="newPwd"
                                    (keypress)="keyPresshas($event)">
                                <span (click)="eyeToggelForNewPassword()" class="eyeIcon"><i
                                        [ngClass]="eyeShowForNew ? 'fa fa-eye' : 'fa fa-eye-slash '" class="icon"
                                        aria-hidden="true"></i></span>
                                <div *ngIf="changePasswordForm.controls['newPwd'].hasError('required') && changePasswordForm.controls['newPwd'].touched"
                                    class="failed-validation" style="color:red;">
                                    New Password Required
                                </div>
                                <div *ngIf="(changePasswordForm.controls['newPwd'].hasError('passwordStrength'))"
                                    class="failed-validation" style="color:red">
                                    Password must have One Upper,LowerCase,Alphabetic And Special Character(except #
                                    symbol)
                                </div>
                                <div *ngIf="changePasswordForm.controls['newPwd'].hasError('minlength')"
                                    class="failed-validation" style="color:red">
                                    Password must have 8 characters
                                </div>
                            </div>

                        </div><br>
                        <div class="row">
                            <div class="col-md-6">
                                <label style="cursor: pointer;">Confirm New Password : <span
                                        class="text-danger">*</span></label>



                            </div>
                            <div class="col-md-6">
                                <input [type]="showConformPassword ? 'text' : 'password'" class="form-control"
                                    placeholder="Confirm New Password" formControlName="confirmNewPwd"
                                    (keypress)="keyPresshas($event)">
                                <span (click)="eyeToggelForComformPassword()" class="eyeIcon"><i
                                        [ngClass]="eyeShowForConform ? 'fa fa-eye' : 'fa fa-eye-slash '" class="icon"
                                        aria-hidden="true"></i></span>
                                <div *ngIf="changePasswordForm.controls['confirmNewPwd'].hasError('required') && changePasswordForm.controls['confirmNewPwd'].touched"
                                    class="failed-validation" style="color:red;">
                                    Confirm New Password Required
                                </div>
                                <div *ngIf="changePasswordForm.controls['confirmNewPwd'].hasError('mustMatch')"
                                    style="color:red;">
                                    Passwords Must Match
                                </div>
                            </div>

                        </div>
                    </form>
                </div>

            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-success" data-dismiss="modal"
                    [disabled]="!changePasswordForm.valid" (click)="updatePassword()">Update</button>
                <button type="button" *ngIf="pwdStatus" class="btn btn-danger" data-dismiss="modal"
                    (click)="reset()">Close</button>
            </div>

        </div>
    </div>
</div>